import { yup } from '@jbc-year-end-adj/common/yup';
import { FileType } from '@jbc-year-end-adj/2024/types';
import { Attachment as AttachmentType } from './query';

export type Schema = {
  attachments: Attachment[];
};

type Attachment = {
  id?: string;
  file: File | FileType;
};

export const schema = yup.object({
  attachments: yup.array().of(
    yup.object({
      id: yup.string().nullable(),
      file: yup.mixed<File | FileType>().required()
    })
  )
});

export const generateDefaultValues = (attachments: AttachmentType[]): Schema => {
  return { attachments: attachments };
};
